export default "__VITE_ASSET__BOkbR8my__"